<template>
  <TransactionTemplate
    :getHeaderToolbar="getHeaderToolbar"
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="getBackButtonRoute"
    ref="bank-account"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :warningSummary="warningSummary"
  />
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { mapGetters } from "vuex";
import TransactionTemplate from "../../templates/transaction.vue";
import { BankAccountsServices } from "../../_services/api/finance/bankAccounts";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { GLFactorService } from "../../_services/api/gl/gl-factor.service";
export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
      reload: false,
      validationSummary: [],
      serverError: {},
      warningSummary: [],
      backRoute: "/bank-accounts",
      dataModel: {
        Code: undefined,
        FXOpeningBalance: 0.0,
        OpeningBalance: 0.0,
        ExchangeRate: 0.0,
        Status: undefined,
        ThisFiscalPeriod: undefined,
        ThisFiscalYear: undefined,
        ReceiptTotal: 0,
        BankAccountName: undefined,
        BankBranch: undefined,
        BankAccountCode: undefined,
        BSBNO: undefined,
        AccountNumber: undefined,
        GLChart: undefined,
        VarianceGLAccountCode: undefined,
        VarianceGLAccountDescription: undefined,
        StartDate: undefined,
        ControlAccount: undefined,
        ExportCode: undefined,
        UserBank: undefined,
        AbaUserCode: undefined,
        RecordId: undefined,
        // CurrencyCode: undefined,
      },
      BaseCurrency: "AUD",
      CompanyCode: undefined,
      CurrencyCode: "AUD",
      HeaderFormInstane: undefined,
    };
  },
  computed: {
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    getBackButtonRoute() {
      return this.backRoute;
    },
    getDataModel() {
      return this.dataModel;
    },
    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: "Bank Accounts-Create ",
          pdf: false,
          audit: false,
          status: true,
          notes: false,
          save: true,
          saveCallback: this.saveBankAccount,
        },
      };
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          formContentReady: this.onFormContentReady,
          title: {
            // createModeIsEditMode: true,
            primary: {
              primary: {
                dataField:
                  this.baseView.mode != "create"
                    ? "BankAccountCode"
                    : undefined,
                text: this.isCreateMode() ? "Create Bank Account" : "",
              },
              secondary: {
                dataField: undefined,
                text: "",
              },
            },
            secondary: {
              dataField:
                this.baseView.mode != "create" ? "AccountNumber" : undefined,
              text: `${
                this.baseView.mode != "create" ? this.dataModel.BSBNO + " " : ""
              }`,
            },
          },

          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Code",
                      dataField: "Code",
                      allowUpdate: false,
                      visible: false,
                      required: true,
                    },

                    {
                      screenField: "BankAccountName",
                      allowUpdate: true,
                      visible: true,
                      label: {
                        text: "Bank Name",
                      },
                      editorOptions: {
                        readOnly: this.isEditMode(),
                        maxLength: 10,
                      },
                      required: true,
                    },
                    {
                      screenField: "BankBranch",
                      allowUpdate: true,
                      visible: true,
                      label: {
                        text: "Branch",
                      },
                      editorOptions: {
                        readOnly: this.isEditMode(),
                        maxLength: 15,
                      },
                      required: true,
                    },
                    {
                      screenField: "BankAccountCode",
                      allowUpdate: true,
                      visible: true,
                      label: {
                        text: "Account Name",
                      },
                      editorOptions: {
                        maxLength: 26,
                      },
                      required: true,
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          screenField: "BSBNO",
                          allowUpdate: true,
                          visible: true,
                          label: {
                            text: "BSB",
                          },
                          editorOptions: {
                            readOnly: this.isEditMode(),
                            maxLength: 15,
                          },
                          required: true,
                        },
                        {
                          screenField: "BankAccountNo",
                          dataField: "AccountNumber",
                          label: {
                            text: "Account",
                          },
                          allowUpdate: true,
                          visible: true,
                          editorOptions: {
                            readOnly: this.isEditMode(),
                            maxLength: 10,
                          },
                          required: true,
                        },
                      ],
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: this.isEditMode() ? "GLChart" : "GLAccount",
                      allowUpdate: true,
                      searchExpr: this.isEditMode()
                        ? undefined
                        : "AccountSearchText",
                      editorOptions: {
                        readOnly: this.isEditMode(),
                      },
                      visible: true,
                      label: {
                        text: "GL Account",
                      },
                      defaultValue: this.dataModel.ControlAccount,
                      required: true,
                    },
                    {
                      screenField: "VarianceGLAccountCode",
                      dataField: "VarianceGLAccountCode",
                      label: {
                        text: "Variance  Account",
                      },
                      allowUpdate: false,
                      visible: false,
                      required: this.isCreateMode(),
                    },
                    {
                      screenField: "VarianceGLAccountDescription",
                      dataField: "VarianceGLAccountDescription",
                      label: {
                        text: "Variance  Account",
                      },
                      allowUpdate: true,
                      editorOptions: {
                        readOnly: true,
                      },
                      visible: true,
                      required: this.isCreateMode(),
                    },
                    {
                      screenField: "ExportCode",
                      allowUpdate:
                        this.dataModel.CurrencyCode == this.BaseCurrency,
                      editorOptions: {
                        maxLength: 10,
                      },
                      visible: true,
                    },
                    {
                      screenField: "UserBank",
                      allowUpdate:
                        this.dataModel.CurrencyCode == this.BaseCurrency,
                      visible: true,
                      editorOptions: {
                        maxLength: 3,
                      },
                    },
                    {
                      screenField: "AbaUserCode",
                      allowUpdate:
                        this.dataModel.CurrencyCode == this.BaseCurrency,
                      label: {
                        text: "ABA Code",
                      },
                      visible: true,
                      editorOptions: {
                        maxLength: 6,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Currency",
                      allowUpdate: this.isCreateMode(),
                      visible: true,
                      defaultValue: "AUD",
                      required: true,
                      editorOptions: {
                        onValueChanged: async (e) => {
                          if (e.event) {
                            this.onCurrencyChanged(e);
                          }
                        },
                      },
                    },
                    {
                      screenField: "StartDate",
                      allowUpdate: this.isCreateMode(),
                      visible: true,
                      label: {
                        text: "Reconcile From",
                      },
                      required: true,
                      editorOptions: {
                        max: new Date().toSaveDate(),
                        onValueChanged: (reconciledFrom) =>
                          this.reconciledFromChanged(reconciledFrom),
                      },
                    },
                    {
                      screenField: "OpeningBalance",
                      dataField: "FXOpeningBalance",
                      label: {
                        text: `Opening Balance (AUD)`,
                      },
                      allowUpdate: true,
                      visible: true,
                      required: true,
                      cssClass: "fx-currency",
                      editorOptions: {
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.onFXOpeningBalanceChanged(e);
                          }
                        },
                        readOnly: this.isEditMode(),
                      },
                    },
                    {
                      screenField: "ExchangeRate",
                      editorOptions: {
                        onValueChanged: (e) => {
                          this.onExchangeRateChanged(e);
                        },
                        min: 0,
                        readOnly:
                          this.BaseCurrency == this.dataModel.CurrencyCode ||
                          this.isEditMode(),
                      },
                      validationRules: [
                        {
                          type: "custom",
                          validationCallback: ({ value, rule }) => {
                            rule.message = `Exchange rate must be greater than 0.000.`;
                            return value > 0;
                          },
                        },
                      ],
                    },
                    {
                      screenField: "OpeningBalance",
                      dataField: "OpeningBalance",
                      label: {
                        text: `Opening Balance (${this.BaseCurrency})`,
                      },
                      allowUpdate: true,
                      visible: true,
                      required: true,
                      editorOptions: {
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.onOpeningBalanceChanged(e);
                          }
                        },
                        readOnly: this.isEditMode(),
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      };
    },
    getScreenJson() {
      return {
        title: "Bank Accounts",
        endpoint: {
          primary: undefined,
        },
        footerData: {
          footerItems: [],
        },
      };
    },
  },
  async created() {
    this.initialized();
  },
  methods: {
    onFormContentReady(e) {
      if (e && this.baseView.mode != "review" && this.loaded)
        setTimeout(() => {
          var headerToolBarForm = e.component;
          this.HeaderFormInstane = e.component;
          if (
            headerToolBarForm &&
            headerToolBarForm.getEditor("BankAccountName")
          )
            headerToolBarForm
              .getEditor("BankAccountName")
              .instance()
              .focus();
        }, 500);
    },
    changeOpeningBalanceLable() {
      if (this.HeaderFormInstane) {
        var element = this.HeaderFormInstane.getEditor("FXOpeningBalance");
        element.option("label", `Opening Balance (${this.CurrencyCode})`);
        var item = document.querySelectorAll(
          ".fx-currency .dx-field-item-label-content .dx-field-item-label-text"
        );
        if (item.length > 0) {
          item[0].innerHTML = `Opening Balance (${this.CurrencyCode})`;
        }
      }
    },
    onExchangeRateChanged(e) {
      if (e.value > 0.0 && this.dataModel.FXOpeningBalance != 0) {
        this.dataModel.OpeningBalance =
          this.dataModel.FXOpeningBalance / e.value;
      } else if (e.value <= 0 && this.dataModel.OpeningBalance > 0) {
        this.dataModel.ExchangeRate =
          this.dataModel.FXOpeningBalance / this.dataModel.OpeningBalance;
      } else if (e.value <= 0) {
        this.dataModel.ExchangeRate = e.previousValue;
      }
    },
    onFXOpeningBalanceChanged(e) {
      if (this.BaseCurrency == this.dataModel.CurrencyCode) {
        this.dataModel.OpeningBalance = e.value;
      } else if (this.dataModel.ExchangeRate != 0) {
        this.dataModel.OpeningBalance = e.value / this.dataModel.ExchangeRate;
      }
    },
    onOpeningBalanceChanged(e) {
      if (e.value == 0) {
        this.dataModel.FXOpeningBalance = 0;
      } else if (this.BaseCurrency == this.dataModel.CurrencyCode) {
        this.dataModel.FXOpeningBalance = e.value;
      } else if (this.dataModel.FXOpeningBalance == 0) {
        if (this.dataModel.ExchangeRate != 0) {
          this.dataModel.FXOpeningBalance =
            e.value * this.dataModel.ExchangeRate;
        }
      } else if (e.value > 0) {
        this.dataModel.ExchangeRate =
          this.dataModel.FXOpeningBalance / this.dataModel.OpeningBalance;
      }
    },
    async onCurrencyChanged(e) {
      this.CurrencyCode = e.value;
      this.changeOpeningBalanceLable();
      CompanyCurrencyService.getByCompanyCodeAndCurrencyCode(
        this.CompanyCode,
        e.value
      ).then((res) => {
        if (res.data.value.length > 0)
          this.dataModel.ExchangeRate = res.data.value[0].GroupRate;
        if (e.value != this.BaseCurrency) {
          this.dataModel.ExportCode = undefined;
          this.dataModel.UserBank = undefined;
          this.dataModel.AbaUserCode = undefined;
        }
      });
    },
    async reconciledFromChanged({ value }) {
      var reconciledFrom = new Date(value).toISOString();
      await BankAccountsServices.getThisFiscalPeriodAndYear(
        reconciledFrom
      ).then(({ data }) => {
        if (data.value.length > 0) {
          this.dataModel.ThisFiscalPeriod = data.value[0].ThisFiscalPeriod;
          this.dataModel.ThisFiscalYear = data.value[0].ThisPeriodFiscalYear;
        }
      });
    },
    populateNestedColumns(columns) {
      this.parseFormColumns(columns);
    },
    isCreateMode() {
      return this.baseView.mode == "create";
    },
    isEditMode() {
      return this.baseView.mode == "edit" || this.baseView.mode == "review";
    },
    async initialized() {
      if (this.isCreateMode()) {
        this.dataModel.Status = "D";
        this.dataModel.StartDate = new Date().toSaveDate();
        await BankAccountsServices.getHighestBankRecordCode().then(
          ({ data }) => {
            this.dataModel.Code = data.value[0].Code + 1;
          }
        );
        await CompanyService.getCompany()
          .then(async (res) => {
            let companyDetails = res.data.value[0];
            if (companyDetails) {
              this.BaseCurrency = companyDetails.CurrencyCode;
              this.CompanyCode = companyDetails.Code;
            } else {
              this.BaseCurrency = "AUD";
              this.dataModel.ExchangeRate = 1.0;
            }
            await CompanyCurrencyService.getByCompanyCodeAndCurrencyCode(
              companyDetails.Code,
              companyDetails.CurrencyCode
            ).then((res) => {
              this.dataModel.ExchangeRate = res.data.value[0].GroupRate;
            });
          })
          .catch(() => {
            this.BaseCurrency = "AUD";
            this.dataModel.ExchangeRate = 1.0;
          });
      } else if (this.isEditMode()) {
        this.dataModel.Status = "A";
        await BankAccountsServices.getBankRecordByCode(this.baseView.id).then(
          async ({ data }) => {
            this.dataModel.Code = this.baseView.id;
            this.dataModel.BankAccountName = data.value[0].CompanyBank;
            this.dataModel.BankBranch = data.value[0].BankBranch;
            this.dataModel.BankAccountCode = data.value[0].AccountName;
            this.dataModel.BSBNO = data.value[0].BsbNo;
            this.dataModel.AccountNumber = data.value[0].AccountNo;
            this.dataModel.GLChart = data.value[0].ComputedControlAccount;
            this.dataModel.StartDate = data.value[0].OpeningBalanceDate;
            this.dataModel.OpeningBalance = data.value[0].OpeningBalance;
            this.dataModel.FXOpeningBalance = data.value[0].FXOpeningBalance;
            this.dataModel.ExportCode = data.value[0].ExportCode;
            this.dataModel.UserBank = data.value[0].UserBank;
            this.dataModel.AbaUserCode = data.value[0].AbaUserCode;
            this.dataModel.RecordId = data.value[0].RecordId;
            this.dataModel.ControlAccount =
              data.value[0].ComputedControlAccount;
            this.dataModel.ExchangeRate = data.value[0].ExchangeRate;
            this.dataModel.CurrencyCode = data.value[0].CurrencyCode;

            await BankAccountsServices.getThisFiscalPeriodAndYear(
              new Date(data.value[0].OpeningBalanceDate).toFilterDateString()
            ).then(({ data }) => {
              if (data.value.length > 0) {
                this.dataModel.ThisFiscalPeriod =
                  data.value[0].ThisFiscalPeriod;
                this.dataModel.ThisFiscalYear =
                  data.value[0].ThisPeriodFiscalYear;
              }
              this.reload = false;
              this.loaded = true;
              this.setLoading = false;
            });
          }
        );

        await CompanyService.getCompany().then((res) => {
          let companyDetails = res.data.value[0];
          if (companyDetails) {
            this.BaseCurrency = companyDetails.CurrencyCode;
            this.CompanyCode = companyDetails.Code;
          }
        });
      }

      await GLFactorService.getByCode(43).then((res) => {
        this.dataModel.VarianceGLAccountCode = res.data.value[0].GLChartCode;
        this.dataModel.VarianceGLAccountDescription = res.data.value[0].Comment;
      });

      this.loaded = true;
    },
    async saveBankAccount(data) {
      let payload = {
        AbaUserCode: data.AbaUserCode,
        AccountName: data.BankAccountCode,
        BsbNo: data.BSBNO,
        ControlAccount: parseInt(data.GLChart),
        FXOpeningBalance: data.FXOpeningBalance,
        OpeningBalance: data.OpeningBalance,
        ExchangeRate: data.ExchangeRate,
        CurrencyCode: data.CurrencyCode,
        VarianceGLAccountCode: 0,
        Code: data.Code,
        CompanyBank: data.BankAccountName,
        AccountCode: data.AccountNumber,
        BankBranch: data.BankBranch,
        ExportCode: data.ExportCode,
        OpeningBalanceDate: new Date(data.StartDate).toSaveDate(),
        UserBank: data.UserBank,
        OpeningBalanceFiscalPeriod: this.dataModel.ThisFiscalPeriod,
        OpeningBalanceFiscalYear: this.dataModel.ThisFiscalYear,
        PaymentTotal: 0,
        ReceiptTotal: this.isCreateMode() ? this.dataModel.ReceiptTotal : 0,
        StatementBalance: 0,
        StatementDate: null,
        BookBalance:
          data.OpeningBalance +
          this.dataModel.ReceiptTotal -
          this.isCreateMode()
            ? 0
            : 0,
        RecordId: this.isEditMode ? this.dataModel.RecordId : "",
      };

      await BankAccountsServices.saveBankRecord(payload).then((res) => {
        this.setIgnoreRouteChangeConfirmation();
        this.$notify(
          `${res.data.AccountName}  ${res.data.AccountCode} ${
            this.isCreateMode() ? "created" : "Updated"
          } successfully`,
          "success"
        );
        if (this.isCreateMode()) {
          this.$router
            .push({ path: `/bank-accounts/review/${res.data.Code}` })
            .then(() => {
              this.reload = true;
              this.initialized();
            });
        } else {
          this.$router.push({ path: `/bank-accounts` });
        }
      });
    },
  },
};
</script>
